import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic-golf-course",
  "use": "ic-golf-course-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ic-golf-course\">\n    <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n    <circle cx=\"19.5\" cy=\"19.5\" r=\"1.5\" />\n    <path d=\"M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol